import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardRestService } from '../dashboard-rest.service';
import { AuthenticationService } from '../../../libraries/libraries.module';
import { formatRupiah } from 'apps/admin-web/src/app/shared/utils';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-withdraw-detail',
  templateUrl: 'withdraw-detail.component.html',
  styleUrls: ['./withdraw-detail.component.scss']
})
export class WithdrawDetailComponent implements OnInit {
  @Input() data: any;
  @Output() withdrawSuccess = new EventEmitter<void>();
  formatRupiah = formatRupiah;
  isLoading: boolean = false;
  isDealership: boolean = false;
  isOpen: boolean = false;
  withdrawValue: number = 100000;
  loadingProfileDealer: boolean = false;
  profileDealer: {
    cp?: string;
    bankAccount?: string;
    bankName?: string;
  } = {};
  balance: number = 100000;
  approvalStatus: string = 'pending';
  formData: {
    status: string;
    proofOfPayment?: string;
    rejectNote?: string;
  } = {
    status: 'pending',
    proofOfPayment: '',
    rejectNote: ''
  };

  openModal() {
    this.isOpen = true;
    console.log('Opening withdraw detail modal for data:', this.data);
  }

  closeModal() {
    this.isOpen = false;
  }

  getStatusColor(status: string) {
    if (!status) return 'warning';

    const normalizedStatus = status.toLowerCase();

    if (normalizedStatus == 'pending') return 'warning';
    if (normalizedStatus == 'success') return 'success';
    if (normalizedStatus == 'rejected') return 'danger';
  }

  constructor(private _DashboardRest: DashboardRestService, public _authentication: AuthenticationService) {}

  onApprove() {
    if (!this.data?._id) {
      console.error('No withdrawal data available');
      return;
    }

    // Validation for required fields based on approval status
    if (this.approvalStatus === 'approved' && !this.formData.proofOfPayment) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Bukti pembayaran wajib diisi.'
      });
      return;
    }

    if (this.approvalStatus === 'rejected' && !this.formData.rejectNote) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Catatan reject wajib diisi.'
      });
      return;
    }

    this.isLoading = true;

    const payload = {
      _id: this.data._id,
      status: this.approvalStatus === 'approved' ? 'success' : 'rejected',
      ...(this.approvalStatus === 'approved' && { proofOfPayment: this.formData.proofOfPayment }),
      ...(this.approvalStatus === 'rejected' && { rejectNote: this.formData.rejectNote })
    };

    this._DashboardRest.approveWithdraw(payload).subscribe({
      next: res => {
        this.isLoading = false;
        this.closeModal();
        Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: 'Update status withdraw berhasil.'
        });
        // Emit success event to trigger table refresh
        this.withdrawSuccess.emit();
      },
      error: err => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err?.response?.data?.message || 'Something went wrong!'
        });
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {}
}
